import { atom } from 'recoil';

/**
 * 관리자 로그인 여부.
 * 화면에 관리 버튼을 보일지 결정하는 UI 플래그일 뿐이다.
 * 실제 쓰기 권한은 Supabase RLS 가 통제한다.
 */
export const isAdminState = atom<boolean>({
  key: 'isAdminState',
  default: false,
});
